import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { HttpClientModule } from '@angular/common/http';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { IonicStorageModule } from '@ionic/storage-angular';
import { FirebaseAnalytics } from '@awesome-cordova-plugins/firebase-analytics/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { SafePipe } from '../pipes/safe';

@NgModule({
  declarations: [
      AppComponent,
      SafePipe
  ],
  entryComponents: [],
  imports: [
      BrowserModule, 
      IonicModule.forRoot(), 
      AppRoutingModule,
      HttpClientModule,
      IonicStorageModule.forRoot()
  ],
  providers: [
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      Geolocation,
      FirebaseAnalytics
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
